import {
  bigint,
  foreignKey,
  index,
  pgEnum,
  pgTable,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';
import { organization_site } from '@trashlab/api/src/domains/dispatch/schemas/organization-site';
import { decimal } from '@trashlab/api/src/domains/core/schemas/base-template';
import { Decimal } from 'decimal.js';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const distance_formula = pgEnum('distance_formula', [
  'HAVERSINE',
  'GOOGLE_MAPS',
]);

export const distance_fee = pgTable(
  'distance_fee',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    name: varchar('name', { length: 255 }).notNull(),
    // You can use { mode: "bigint" } if numbers are exceeding js number limitations
    flatFeeBeyondMinMiles: bigint('flatFeeBeyondMinMiles', { mode: 'number' })
      .default(0)
      .notNull(),
    minMilesToQualify: decimal('minMilesToQualify', { precision: 7, scale: 4 })
      .default(new Decimal(0))
      .notNull(),
    originLocationId: uuid('originLocationId').notNull(),
    // You can use { mode: "bigint" } if numbers are exceeding js number limitations
    perMileFeeBeyondMinimum: bigint('perMileFeeBeyondMinimum', {
      mode: 'number',
    })
      .default(0)
      .notNull(),
    distanceFormula: distance_formula('distanceFormula')
      .default('HAVERSINE')
      .notNull(),
    distanceUnit: varchar('distanceUnit', {
      length: 16,
      enum: ['MILES', 'KILOMETERS'],
    })
      .default('MILES')
      .notNull(),
  },
  (table) => {
    return {
      createdAtTs_idx: index('distance_fee_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('distance_fee_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('distance_fee_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('distance_fee_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('distance_fee_versionNumber_idx').on(
        table.versionNumber,
      ),

      originLocationId_idx: index('distance_fee_originLocationId_idx').on(
        table.originLocationId,
      ),

      //foreign keys
      distance_fee_originLocationId_fkey: foreignKey({
        columns: [table.originLocationId],
        foreignColumns: [organization_site.id],
        name: 'distance_fee_originLocationId_fkey',
      }),
    };
  },
);

export const distance_fee_history = pgTable('distance_fee_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
  name: varchar('name', { length: 255 }),
  // You can use { mode: "bigint" } if numbers are exceeding js number limitations
  flatFeeBeyondMinMiles: bigint('flatFeeBeyondMinMiles', { mode: 'number' }),
  minMilesToQualify: decimal('minMilesToQualify', { precision: 7, scale: 4 }),
  originLocationId: uuid('originLocationId'),
  // You can use { mode: "bigint" } if numbers are exceeding js number limitations
  perMileFeeBeyondMinimum: bigint('perMileFeeBeyondMinimum', {
    mode: 'number',
  }),
  distanceFormula: distance_formula('distanceFormula'),
  distanceUnit: varchar('distanceUnit', {
    length: 16,
    enum: ['MILES', 'KILOMETERS'],
  }),
});
